import React, { useRef } from "react"
import ReactTable, {
  RowInfo,
  Column,
  SortingRule,
  ControlledStateOverrideProps,
} from "react-table-6"
import { iStringIndex } from "../../definitions/interfaces"
import { useData } from "../../hooks/useData"

interface iProps {
  link: string
  onClick: (rowInfo: RowInfo) => void
  columns: Column[]
  defaultSorted: SortingRule[]
}

const Table = <TQuery extends iStringIndex, TData>({
  link,
  onClick,
  columns,
  defaultSorted,
}: iProps) => {
  const _size = useRef<number>(50)
  const { data, loading, setQuery, total } = useData<TQuery, TData>({
    link,
    defaultQuery: {} as TQuery,
    shouldPingForData: false,
    shouldQueryOnStart: false,
  })

  const fetchData = (state: ControlledStateOverrideProps) => {
    const { page, pageSize, sorted, filtered } = state

    const query: iStringIndex = {
      sort: {},
    }
    filtered.forEach((f) => {
      query[f.id] = f.value
    })
    if (page) {
      query.page = page + 1
    }

    sorted.forEach((s) => {
      query.sort[s.id] = s.desc ? -1 : 1
    })

    if (pageSize) {
      _size.current = pageSize
    }
    query.pageSize = pageSize
    setQuery(query as TQuery, true)
  }

  return (
    <ReactTable
      manual
      filterable
      resizable
      className="-highlight"
      loading={loading}
      data={data}
      columns={columns}
      pages={Math.ceil(total / _size.current)}
      showPaginationTop={true}
      defaultPageSize={50}
      defaultSorted={defaultSorted}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getTdProps={(state: any, rowInfo: any) => {
        return {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick: () => {
            onClick(rowInfo)
          },
        }
      }}
      onFetchData={fetchData}
    />
  )
}

export default Table
